import { format, startOfWeek, startOfMonth, endOfMonth, subMonths } from 'date-fns';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
export const rs = (v) => `₹${Number(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const dmy = (d) => (d ? String(d).slice(0, 10).split('-').reverse().join('-') : '—');
const f = (d) => format(d, 'yyyy-MM-dd');

export const QUICK = [
  ['today', 'Today', (n) => [n, n]],
  ['this_week', 'This Week', (n) => [startOfWeek(n, { weekStartsOn: 1 }), n]],
  ['this_month', 'This Month', (n) => [startOfMonth(n), n]],
  ['last_month', 'Last Month', (n) => [startOfMonth(subMonths(n, 1)), endOfMonth(subMonths(n, 1))]],
  ['custom', 'Custom Date', null],
];
export const quickRange = (key) => {
  const q = QUICK.find(([k]) => k === key);
  if (!q || !q[2]) return null;
  const [a, b] = q[2](new Date());
  return { date_from: f(a), date_to: f(b) };
};

export const STATUS = { fully_paid: ['Paid', 'bg-emerald-100 text-emerald-800'], partially_paid: ['Partial', 'bg-amber-100 text-amber-800'], pending: ['Pending', 'bg-red-100 text-red-700'] };
export const BUCKET_LABEL = { '0-30': '0–30 Days', '31-60': '31–60 Days', '61-90': '61–90 Days', '90+': 'Above 90 Days' };
